const view_manager = require('civicsUtils/view_manager');
const attachment_model = require('civicsModels/attachment_model');
const Utils = require('civicsUtils/general_utilities');

define(function(require) {
	return {
		convertAttachments:function(attachments){
			if(!this.isVersion85()){
				return this.completeAttachmentUris(attachments);
			} else {
				if(attachments.length>0){
					if(attachments[0].attachment && attachments[0].name){//saved instrumentsuse attachment for the ID and name for name
						return this.convertSavedInstrumentToNewAttachments(attachments)
					} else if(attachments[0].attachment){//instrument and inspection attachments use attachment for the ID and attachmentName for name
						return this.convertInspectionsAndInstrumentsToNewAttachments(attachments)
					} else if(attachments[0].attachmentId){//hearings and reviews use id
						return this.convertHearingsReviewsAndServiceRequestsToNewAttachments(attachments)
					}
					return attachments;
				}
				return attachments;
			}
		},
		completeAttachmentUris:function(attachments){
			var attachmentModel = new attachment_model();
			$.each(attachments,function(index,el){
				var connector = el.documentUri != null ? (el.documentUri.includes('?') ? '&' : '?' ) : '?';
				var fName = (view_manager.versionRange('8.8.0.0')) ? el.filename : el.title ;
				el.documentUri = (fName && el.documentUri) ? attachmentModel.urlRoot()+el.documentUri+connector+'fname='+ encodeURIComponent(fName) : "";
				el.thumbnailUri = (fName && el.documentUri) ? attachmentModel.urlRoot()+el.thumbnailUri+connector+'fname='+ encodeURIComponent(fName) : "";
			})
			return attachments;
		},
		convertSavedInstrumentToNewAttachments: function(attachments){//name and attachment
			var attachmentModel = new attachment_model()
			var retArray = [];
			$.each(attachments, function(index, el) {
				var att = {
					title: el.name,
					documentUri: attachmentModel.urlRoot() + '/' + el.attachment + '?GetIcon=false&fname=' + el.name,
					thumbnailUri: attachmentModel.urlRoot() + '/' + el.attachment + '?GetIcon=true&fname=' + el.name,
					addedDateTime: el.addedDate,
					id: el.attachment,
					description:el.attachmentDescription
				}
				retArray.push(att)
			});
			if( __DEV__){
				console.log('retArray: ',retArray);
				console.log('attachments',attachments);
			}
			return retArray;
		},
		convertHearingsReviewsAndServiceRequestsToNewAttachments: function(attachments) {
			var attachmentModel = new attachment_model()
			var retArray = [];
			$.each(attachments, function(index, el) {
				var att = {
					title: el.name,
					documentUri: attachmentModel.urlRoot() + '/' + el.attachmentId + '?GetIcon=false&fname=' + el.name,
					thumbnailUri: attachmentModel.urlRoot() + '/' + el.attachmentId + '?GetIcon=true',
					addedDateTime: el.addedDate,
					id: el.attachmentId,
					description:el.description
				}
				retArray.push(att)
			});
			if( __DEV__){
				console.log('retArray: ',retArray);
				console.log('attachments',attachments);
			}
			return retArray;
		},
		convertInspectionsAndInstrumentsToNewAttachments: function(attachments) {
			var attachmentModel = new attachment_model()
			var retArray = [];
			$.each(attachments, function(index, el) {
				var att = {
					title: el.attachmentName,
					documentUri: attachmentModel.urlRoot() + '/' + el.attachment + '?GetIcon=false&fname=' + el.attachmentName,
					thumbnailUri: attachmentModel.urlRoot() + '/' + el.attachment + '?GetIcon=true&fname=' + el.attachmentName,
					addedDateTime: el.addedDate,
					id: el.attachment,
					description:el.attachmentDescription
				}
				retArray.push(att)
			});
			if( __DEV__){
				console.log('retArray: ',retArray);
				console.log('attachments',attachments);
			}
			return retArray;
		},
		isVersion85:function(){
			var config = view_manager.globalConfig().toJSON();
			return config.ipsVersion <= 8.5;
		}
	}
});
